import { WestnetzOnlyAccessGuard } from './guards/westnetz-only-access.guard';
import { CanDeactivateGuard } from './../common/can-deactivate/can-deactivate.guard';
import { NgModule } from '@angular/core';
import { mapToCanActivate, mapToCanDeactivate, RouterModule, Routes } from '@angular/router';
import { NetzbetreiberPageComponent } from './netzbetreiber-page/netzbetreiber-page.component';
import { NetzbetreiberDetailComponent } from './netzbetreiber-detail/netzbetreiber-detail.component';

export const netzbetreiberRoutes: Routes = [
    {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
    },
    {   // lists all Netzbetreiber
        path: 'list',
        component: NetzbetreiberPageComponent,
    },
    {
        path: 'detail',
        component: NetzbetreiberDetailComponent,
        canDeactivate: mapToCanDeactivate([
            CanDeactivateGuard,
        ]),
        canActivate: mapToCanActivate([
            WestnetzOnlyAccessGuard,
        ]),
    },
];

@NgModule({
    imports: [
        RouterModule.forChild(netzbetreiberRoutes),
    ],
    exports: [
        RouterModule,
    ],
})
export class NetzbetreiberRoutingModule {
}
